document.addEventListener("DOMContentLoaded", async function () {
  const dialog = document.querySelector(".popup-preorder-container");
  const closeBtns = document.querySelectorAll(".popup-preorder-close-btn");
  const addToCartBtn = document.querySelector(
    ".add-to-cart-container .cta-btn"
  );
  const preOrderAddToCartBtn = document.querySelector(
    ".popup-preorder-container .popup-preorder-addToCart"
  );
  var selectedVariantId;

  addToCartBtn.addEventListener("click", checkPreorderState);
  preOrderAddToCartBtn.addEventListener("click", addVariantToCart);

  function checkPreorderState(){
    const selectedSwatch = document.querySelector(
      ".product-landing-section .color-container .color-swatch.selected"
    );
    var preOrder;

    if(!selectedSwatch){
      var priceContainer = document.querySelector(
      ".product-landing-section.desk .price-container.active");

      preOrder = priceContainer.dataset["variantPreorder"];
      selectedVariantId = priceContainer.dataset.variantId;

    }else{
      var selectedSwatchParentColorContainer = selectedSwatch.parentElement;

      preOrder = selectedSwatchParentColorContainer.dataset["variantPreorder"];  
      selectedVariantId = selectedSwatchParentColorContainer.dataset.variantId;
    }

    if(preOrder == "false")return;
    showPopuppreorderElem();
  }

  closeBtns.forEach((btn) => btn.addEventListener("click", closepreorderPopup));
  // setTimeout(showPopuppreorderElem, 1000); // Show Popup for preorder after 10s of Document load event.
  
  function showPopuppreorderElem() {
    dialog.showModal();
  }

  function closepreorderPopup() {
    dialog.close();
    openCheck(dialog);
  }

  function openCheck(dialog) {
    if (dialog.open) {
      console.log("Pop up open");
    } else {
      console.log("Pop up closed");
    }
  }

  async function addVariantToCart() {
    
    closepreorderPopup();
    const cartItems = await Shopify.addVariantToCart(selectedVariantId);
    console.log(`updated cart items: ${cartItems}`);
    // const event = new CustomEvent('update-badge');
    // e.target.dispatchEvent(event);
    Shopify.eventBus.emit('add-variant-to-cart');
    // TODO: Update all places where Cart info is shown.
  }
});
